import request from '@/utils/httpRequest'

export function getUserList (params) {
  return request({
    url: `/sys/user/page`,
    method: 'get',
    params
  })
}
export function createUser (data) {
  return request({
    url: `/sys/user/save`,
    method: 'post',
    data
  })
}
export function updateUserInfo (data) {
  return request({
    url: `/sys/user/update`,
    method: 'post',
    data
  })
}
export function getInfoByUserId (userId, params) {
  return request({
    url: `/sys/user/info/${userId}`,
    method: 'get',
    params
  })
}
export function changePassword (data) {
  return request({
    url: `/sys/user/password`,
    method: 'post',
    data
  })
}
export function deleteUser (data) {
  return request({
    url: `/sys/user/delete`,
    method: 'post',
    data
  })
}
export function resetPassword (data) {
  return request({
    url: `/sys/user/resetPassword`,
    method: 'post',
    data
  })
}
